import { useQuery } from '@tanstack/react-query';
import { EQUIPMENT_IDS_QUERY } from 'apollo/queries/equipment-queries';
import { useOpenable } from 'hooks';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';
import { useCheckForMultipleObjects } from 'hooks/utils/useCheckForObjects/useCheckForObjects';
import { useFeatureFlags } from 'utils/features';

export const FREEMIUM_EQUIPMENT_LIMIT = 5;

export default function useEquipmentLimit() {
  const isFreemiumLimited = useFeatureFlags('FREEMIUM_LIMITED');
  const limitReachedOpenable = useOpenable();
  const getEquipmentLimits = useCheckForMultipleObjects(EQUIPMENT_IDS_QUERY, 'equipment', FREEMIUM_EQUIPMENT_LIMIT, {
    archivedOn: { isNull: true },
    deletedOn: { isNull: true },
  });

  const { refetch: refetchEquipmentLimits } = useQuery({
    queryKey: [...useReactQueryBaseKey(), 'limit-equipment-by-id'],
    queryFn: getEquipmentLimits,
    initialData: null,
    enabled: isFreemiumLimited,
  });

  // Returns true when adding `additionalCount` active equipment would exceed the limit and opens the limit dialog.
  async function checkEquipmentLimitReached(additionalCount: number = 1) {
    if (!isFreemiumLimited) {
      return false;
    }
    const { data: activeEquipment } = await refetchEquipmentLimits();
    if (activeEquipment && activeEquipment.length + additionalCount > FREEMIUM_EQUIPMENT_LIMIT) {
      limitReachedOpenable.open();
      return true;
    }
    return false;
  }

  return { isFreemiumLimited, checkEquipmentLimitReached, limitReachedOpenable };
}
